<template>
    <v-container>
        <v-row class="details__card">
            <v-col cols="3" xl="3" lg="3" md="5" sm="12" class="pa-5">
                <v-row>
                    <v-col cols="12" class="d-flex flex-column">
                        <p
                            class="font-weight-bold d-flex flex-column headline pa-0 ma-0 mb-5"
                        >
                            {{ getOfferDetails.contractor.name }}
                        </p>
                        <span
                            ><b>{{ `${$t('offers:title')}` }}:</b>
                            {{ $get(getOfferDetails, 'title', '') }}
                        </span>
                        <span
                            ><b>{{ `${$t('offers:insertionDate')}` }}:</b>
                            {{
                                getOfferDetails.createdAt
                                    ? $moment(getOfferDetails.createdAt).format(
                                          `DD/MM/YYYY`
                                      )
                                    : $t('global:empty')
                            }}</span
                        >
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6" xl="6" lg="8" md="12" sm="12" class="pa-5">
                <v-row>
                    <v-col cols="12"
                        ><v-text-field
                            readonly
                            :value="$get(getOfferDetails, 'title', '')"
                            :label="$t('offers:title')"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12"
                        ><v-text-field
                            readonly
                            :value="
                                $get(getOfferDetails, 'contractor.name', '')
                            "
                            :label="$t('offers:contractor')"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12"
                        ><v-text-field
                            readonly
                            :value="findRepresentative(getOfferDetails)"
                            :label="$t('offers:representative')"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="8"
                        ><v-text-field
                            readonly
                            :value="
                                $get(getOfferDetails, 'offerType.field', '')
                            "
                            :label="$t('offers:offerKind')"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="4"
                        ><v-text-field
                            readonly
                            :value="
                                $get(getOfferDetails, 'customerType.field', '')
                            "
                            :label="$t('offers:customerKind')"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4"
                        ><v-text-field
                            readonly
                            :value="
                                getOfferDetails.expirationDate
                                    ? $moment(
                                          getOfferDetails.expirationDate
                                      ).format('DD-MM-YYYY')
                                    : $t('global:empty')
                            "
                            :label="$t('offers:expirationDate')"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12"
                        ><v-textarea
                            readonly
                            :value="$get(getOfferDetails, 'notes', '')"
                            :label="$t('offers:notes')"
                            no-resize
                            rows="1"
                            auto-grow
                        ></v-textarea>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    i18nOptions: { namespaces: ['global'] },
    computed: {
        ...mapGetters(['getOfferDetails']),
    },
    methods: {
        findRepresentative(item) {
            //add a period after each name
            const id = item.representative
            if (id) {
                const representative = item.contractor?.representatives?.find(
                    e => e._id === id
                )

                return `${this.$get(
                    representative,
                    'name',
                    'Brak'
                )} ${this.$get(representative, 'lastname', '')} ${
                    representative && representative.email ? '•' : ''
                } ${this.$get(representative, `email`, '')} ${
                    representative && representative.phoneNumber ? '•' : ''
                } ${this.$get(representative, 'phoneNumber', '')}`
            }
            return ''
        },
    },
}
</script>
